import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

export const PropositionListWrapper = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const PointWrapper = styled.li`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[8]};
  margin-top: ${({ theme }) => theme.spacing[8]};

  &:first-child {
    margin-top: 0;
  }
`;

export const Icon = styled.img`
  width: 24px;
  height: 24px;
`;

export const PointTitle = styled(Typography).attrs({
  variant: TextStyles['Heading 5'],
})`
  color: ${({ theme }) => theme.colors.highEmphasisBlack};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;
